/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { LowestPriceOfPeriod } from '../../models/lowest-price-of-period';
import { SearchSource } from '../../models/search-source';

export interface GetPricesForPeriodWithFixedDepartureDate$Params {

/**
 * IATA code for airport, city
 */
  departureLocationCode: string;

/**
 * IATA code for airport, city
 */
  destinationLocationCode: string;

/**
 * Show prices starting from this date (yyyy-MM-dd)
 */
  departureDate: string;

/**
 * Number of days to search forward from given startDate
 */
  numberOfDays: number;

/**
 * Travel class
 */
  travelClass?: string;

/**
 * Group by
 */
  groupBy?: string;

/**
 * number of adult travelers
 */
  adults?: number;

/**
 * number of child travelers
 */
  children?: number;

/**
 * number of infant travelers
 */
  infants?: number;

/**
 * direct flights only
 */
  directFlights?: boolean;

/**
 * search source
 */
  searchSource?: SearchSource;

/**
 * locale
 */
  locale?: string;
}

export function getPricesForPeriodWithFixedDepartureDate(http: HttpClient, rootUrl: string, params: GetPricesForPeriodWithFixedDepartureDate$Params, context?: HttpContext): Observable<DapiHttpResponse<LowestPriceOfPeriod>> {
  const rb = new DapiRequestBuilder(rootUrl, getPricesForPeriodWithFixedDepartureDate.PATH, 'get');

  if (params) {
    rb.query('departureLocationCode', params.departureLocationCode, {});
    rb.query('destinationLocationCode', params.destinationLocationCode, {});
    rb.query('departureDate', params.departureDate, {});
    rb.query('numberOfDays', params.numberOfDays, {});
    rb.query('travelClass', params.travelClass, {});
    rb.query('groupBy', params.groupBy, {});
    rb.query('adults', params.adults, {});
    rb.query('children', params.children, {});
    rb.query('infants', params.infants, {});
    rb.query('directFlights', params.directFlights, {});
    rb.query('searchSource', params.searchSource, {});
    rb.query('locale', params.locale, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<LowestPriceOfPeriod>;
    }),
    catchErrorAsJson()
  );
}

getPricesForPeriodWithFixedDepartureDate.PATH = '/api/instantsearch/pricesforperiod/fixeddeparture';
